import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Accountability = GlassFrogModel.extend({

}, {
  resourceName: 'accountabilities',
})

export default Accountability
